/* eslint-disable no-unused-vars */
import store from '@/store';
import { ForgeMessage } from '../../utils/forgeMessageUtils'

export const timeline = {
    state: {
        isPaused: false,
        startDate: null,
        endDate: null,
        currentDate: null,
        intervalTime: 1000,
        hoursPerSecond: 6,     
        timelineData: [],
        timelineScale: 1,
        timelineInterval: null,
        lastValidTagIds: [],
        shouldZoom: false,
        lastTimeLineProcessId: null,
    },
    mutations: {
        SET_IS_PAUSED (state, value) {
            state.isPaused = value;
        },
        SET_START_DATE (state, value) {
            state.startDate = value;
        },
        SET_END_DATE (state, value) {
            state.endDate = value;
        },
        SET_CURRENT_DATE (state, value) {
            state.currentDate = value;
        },
        SET_SPEED (state, value) {
            state.speed = value;
        },
        SET_INTERVAL_TIME (state, value) {
            state.intervalTime = value;
        },
        SET_TIMELINE_DATA: (state, value) => {
            state.timelineData = value;
            state.startDate = new Date(Math.min(...value.map(obj => obj.startDate)));
            state.endDate = new Date(Math.max(...value.map(obj => obj.endDate)));
            state.currentDate = state.startDate;
        },
        SET_LAST_TIME_LINE_PROCESS_ID: (state, value) => {
            state.lastTimeLineProcessId = value;
        }
    },
    actions: {
        RUN_TIMELINE({ dispatch, commit, state }) {
            let dbIds = []
            if (state.startDate.getTime() === state.currentDate.getTime()) {
                store.state.viewer.hideAll();
                dbIds = store.state.forgeService.getTagsInfoData(store.state.timeline.timelineData.map(t => t.tag)).dbIds;
                store.state.viewer.fitToView(dbIds);
            }

            state.timelineInterval = setInterval(() => {
                if (state.isPaused) {
                    clearInterval(state.timelineInterval);
                    state.timelineInterval = null;
                } else if (state.currentDate > state.endDate) {
                    clearInterval(state.timelineInterval);
                    state.timelineInterval = null;
                    console.log("Timeline has ended.");
                    setTimeout(() => {
                        console.log("Fit to view all tags.")
                        store.state.viewer.fitToView(dbIds);
                    }, 1000);
                    ForgeMessage.sendMessageToParent('timeline-ended', {});
                } else {
                    dispatch('UPDATE_ISOLATED_VIEWER_WITH_TIMELINE_DATA');
                    dispatch('INCREMENT_TIMELINE_CURRENT_TIME');
                }
            }, state.intervalTime * state.timelineScale);
        },
        STOP_TIMELINE({ dispatch, commit, state }) {
            //console.log("Timeline has stopped.")
            if (state.timelineInterval) 
                clearInterval(state.timelineInterval);
            state.timelineInterval = null;
            state.timelineData = [];
            state.lastValidTagIds = [];
            state.startDate = null;
            state.endDate = null;
            state.currentDate = null;
            state.isPaused = false;
        },
        PAUSE_TIMELINE({ dispatch, commit, state }) {
            console.log("Timeline has paused.")
            state.isPaused = true;
        },
        RESUME_TIMELINE({ dispatch, commit, state }) {
            console.log("Timeline has resumed.")
            state.isPaused = false;
            dispatch('RUN_TIMELINE');
        },
        UPDATE_ISOLATED_VIEWER_WITH_TIMELINE_DATA ({ dispatch, commit, state }) {
            const validTags = state.timelineData.reduce((acc, obj) => {
                if (state.currentDate >= obj.startDate && state.currentDate <= obj.endDate) {
                    obj.tag.children = obj.tag.children || [];
                    acc.push(obj.tag);
                }
                return acc;
            }, []);

            if (!!state.lastValidTagIds?.length && state.lastValidTagIds.join(",") === validTags.map(t => t.id).join(",")) return;
        
            if (validTags?.length) {
                let options = { totalTime: 3000, intervals: 4, skipZoom: !state.shouldZoom };
                store.state.forgeService.showTagsByIdsWithColorAndAnimation(validTags, options);
                // console.log("Current valid tagIds:", validTags.map(t => t.id).join(", "));
            } else {
                // let instanceTree = store.state.viewer.model.getData().instanceTree;
                // let rootId = instanceTree.getRootId();
                // store.state.viewer.hide(rootId) 
                //console.log("No valid tags at this time.");
            }

            state.lastValidTagIds = validTags.map(t => t.id);
        },
        INCREMENT_TIMELINE_CURRENT_TIME({ dispatch, commit, state }) {
            if (!state.isPaused) {
                let currentDate = state.currentDate;
                let newDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * state.hoursPerSecond);
                ForgeMessage.sendMessageToParent('update-timeline-date', newDate);
                commit('SET_CURRENT_DATE', newDate);
            }
        },
        CHANGE_TIMELINE_SPEED({ dispatch, commit, state }, speed) {
            state.timelineScale = state.hoursPerSecond / speed;
        },
        CHANGE_TIMELINE_ZOOM({ dispatch, commit, state }, shouldZoom) {
            state.shouldZoom = shouldZoom;
        },
    },
    getters: {
        GET_IS_PAUSED (state) {
            return state.isPaused;
        },
        GET_START_DATE (state) {
            return state.startDate;
        },
        GET_END_DATE (state) {
            return state.endDate;
        },
        GET_CURRENT_DATE (state) {
            return state.currentDate;
        },
        GET_SPEED (state) {
            return state.speed;
        },
        GET_INTERVAL_TIME (state) {
            return state.intervalTime;
        },
        GET_TIMELINE_DATA: (state) => {
            return state.timelineData;
        },
        GET_LAST_TIME_LINE_PROCESS_ID: (state) => {
            return state.lastTimeLineProcessId;
        }
    },
}